export const routes = {
    loginRoute: 'login',
    errors: 'errors',
    promo_errors: 'promo_errors',
    promo_messages: 'promo_messages',
    app: 'app',
    promo: 'promo',
    cyber: 'cyber',
    contract: 'contract',
    company: 'company',
    sendReminder: 'sendReminder',
    notConfirmedContract: 'notconfirmed',
    confirmedContract: 'confirmed',
    notConfirmedCyberContract: 'cyber_notconfirmed',
    confirmedCyberContract: 'cyber_confirmed',
    accepted: 'accepted',
    promo_accepted: 'promo_accepted',
    promo_refused: 'promo_refused',
    refused: 'refused',
    promo_expired: 'promo_expired',
    cookiePolicy: 'cookie-policy',
    sendReminderConfirm: 'sendReminderConfirm',
    statusCode201: '201',
    statusCode404: '404',
    statusCode520: '520',
    statusCode301: '301',
};

export const ENABLE_LICENSE_MANAGEMENT = false;
